// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".serviceFee[data-v-78c4efbd]{color:#80869a;display:inline-flex;font-size:12px;font-weight:400;line-height:16px;margin-bottom:8px}.serviceFee__checkbox-wrapper[data-v-78c4efbd]{align-items:center;display:inline-flex}.serviceFee__checkbox[data-v-78c4efbd]{margin-right:16px}.currency[data-v-78c4efbd]{margin:0 5px}.novikov .serviceFee[data-v-78c4efbd]{color:#888}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
